/**
 * Golf Tournament List Reducers
 */
import {
    TOURNAMENTSCORE_ACTION,
    ALL_TOURNAMENTSCORE,
    ADD_TOURNAMENTSCORE,
    EDIT_TOURNAMENTSCORE,
    FETCH_TOURNAMENTSCORE,
    DELETE_TOURNAMENTSCORE,
    FETCH_TOURNAMENTSCORECHART
 } from 'Actions/types';
 
 
 const INIT_STATE = {
    tournamentscorelist:[],
    tournamentscoredetails:[],
    tournamentscorechart:[],
    loading: false,
 };
 
 export default (state = INIT_STATE, action) => {
     switch (action.type) {
         
        case TOURNAMENTSCORE_ACTION:
            return { ...state, loading: true };       

        case ALL_TOURNAMENTSCORE:
            return { ...state, loading: false, tournamentscorelist: action.payload };     
            
        case ADD_TOURNAMENTSCORE:
            return { ...state, loading: false };    

        case EDIT_TOURNAMENTSCORE:
            return { ...state, loading: false }; 

        case FETCH_TOURNAMENTSCORE:
            return { ...state, loading: false, tournamentscoredetails: action.payload };  
            
        case DELETE_TOURNAMENTSCORE:
            return { ...state, loading: false };
            
        case FETCH_TOURNAMENTSCORECHART:
            return { ...state, loading: false, tournamentscorechart: action.payload }; 
        
        default: return { ...state };

     }
 }